import { render, staticRenderFns } from "./settingsTabs.vue?vue&type=template&id=80af1690"
import script from "./settingsTabs.vue?vue&type=script&lang=js"
export * from "./settingsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports